import "../styles/index.css";
import Head from "next/head";

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        {/* Critical resource hints */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link rel="preconnect" href="https://use.typekit.net" />
        <link rel="preconnect" href="https://p.typekit.net" />
        <link rel="preconnect" href="https://o480086.ingest.sentry.io" />
        <link rel="preconnect" href="https://client-objects.s3.us-west-2.amazonaws.com" />

        {/* Font loading optimization */}
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap"
          rel="stylesheet"
        />

        {/* Preload critical assets */}
        {/* may need to update the image extensions if converted to another format*/}
        <link rel="preload" href="/img/hero_home.webp" as="image" />
        <link rel="preload" href="/img/BPI-logo-2022.webp" as="image" />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

export default MyApp;
